// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MetaBlock__container-e0ea3f {
  display: flex;
  box-sizing: border-box;
  position: relative;
  padding: 8px var(--meta-block-padding);
  --meta-block-actions-background: var(--base-0);
  --meta-block-padding: 16px;
}

.MetaBlock__icon-a59588 {
  fill: var(--base-80);
  margin-inline-end: 24px;
}

.MetaBlock__info-f4e997 {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  flex: 1;
}

.MetaBlock__label-d680ef {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
}

.MetaBlock__content-bc04f9 {
  overflow: hidden;
  color: var(--base-110);
}

.MetaBlock__shadow-e47f13 {
  background: linear-gradient(90deg, transparent 0%, var(--meta-block-actions-background) 100%);
  width: 33px;
  height: 56px;
}

.MetaBlock__actions-ed0d83 {
  align-items: center;
  display: none;
  position: absolute;
  top: 0;
  inset-inline-end: 0;
}

.MetaBlock__container-e0ea3f:hover .MetaBlock__actions-ed0d83 {
  display: flex;
}

.MetaBlock__actions-background-b8e7ea {
  align-items: center;
  background-color: var(--meta-block-actions-background);
  display: flex;
}

.MetaBlock__actions-background-b8e7ea > button {
  margin-inline-end: 14px;
}`, "",{"version":3,"sources":["webpack://./src/main/Profile/components/MetaBlock/MetaBlock.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,sCAAA;EAEA,8CAAA;EACA,0BAAA;AAAF;;AAGA;EACE,oBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,OAAA;AAAF;;AAGA;EACE,4BAAA;EACA,8CAAA;EACA,qBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,6FAAA;EACA,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,mBAAA;EACA,sDAAA;EACA,aAAA;AAAF;;AAGA;EACE,uBAAA;AAAF","sourcesContent":[".container {\n  display: flex;\n  box-sizing: border-box;\n  position: relative;\n  padding: 8px var(--meta-block-padding);\n\n  --meta-block-actions-background: var(--base-0);\n  --meta-block-padding: 16px;\n}\n\n.icon {\n  fill: var(--base-80);\n  margin-inline-end: 24px;\n}\n\n.info {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  width: 100%;\n  flex: 1;\n}\n\n.label {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n}\n\n.content {\n  overflow: hidden;\n  color: var(--base-110);\n}\n\n.shadow {\n  background: linear-gradient(90deg, transparent 0%, var(--meta-block-actions-background) 100%);\n  width: 33px;\n  height: 56px;\n}\n\n.actions {\n  align-items: center;\n  display: none;\n  position: absolute;\n  top: 0;\n  inset-inline-end: 0;\n}\n\n.container:hover .actions {\n  display: flex;\n}\n\n.actions-background {\n  align-items: center;\n  background-color: var(--meta-block-actions-background);\n  display: flex;\n}\n\n.actions-background > button {\n  margin-inline-end: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MetaBlock__container-e0ea3f`,
	"icon": `MetaBlock__icon-a59588`,
	"info": `MetaBlock__info-f4e997`,
	"label": `MetaBlock__label-d680ef`,
	"content": `MetaBlock__content-bc04f9`,
	"shadow": `MetaBlock__shadow-e47f13`,
	"actions": `MetaBlock__actions-ed0d83`,
	"actions-background": `MetaBlock__actions-background-b8e7ea`,
	"actionsBackground": `MetaBlock__actions-background-b8e7ea`
};
module.exports = ___CSS_LOADER_EXPORT___;
